export default "__VITE_ASSET__BRQZcXCC__"